import { TableContainer, Table, TableHead, TableBody, TableRow, TableCell, Skeleton } from '@mui/material';
import { CerebroDrawer, CerebroHeading } from '../../shared/components';
import { useDocumentDownloadHistoryQuery } from '../../shared/hooks/Queries/useDocumentDownloadHistoryQuery';
import { DataRoomDocument } from '../../shared/models';
import { DateUtils } from '../../shared/utils';
import { GetDocumentDownloadTypeDescription } from '../../shared/utils/enum';

interface DownloadHistoryDetailProps {
	dataRoomGuid: string | undefined;
	document: DataRoomDocument | null;
	close: () => void;
}

export const DownloadHistoryDetail: React.FC<DownloadHistoryDetailProps> = ({ dataRoomGuid, document, close }) => {
	const historyQuery = useDocumentDownloadHistoryQuery(dataRoomGuid, document?.guid, {
		enabled: document != null,
		retry: false,
	});

	if (historyQuery.isLoading)
		return (
			<>
				<Skeleton height={60} />
				<Skeleton height={60} />
				<Skeleton height={60} />
			</>
		);

	return (
		<CerebroDrawer open={document != null} onClose={() => close()} PaperProps={{ sx: { width: '670px' } }}>
			<CerebroHeading size="h1" gutterBottom>
				{document?.name}
			</CerebroHeading>

			<TableContainer>
				<Table>
					<TableHead>
						<TableRow>
							<TableCell>User</TableCell>
							<TableCell>Organization</TableCell>
							<TableCell>Action</TableCell>
							<TableCell>Date</TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{historyQuery.isLoading && (
							<>
								<Skeleton height={60} />
								<Skeleton height={60} />
								<Skeleton height={60} />
							</>
						)}
						{historyQuery.isSuccess && (
							<>
								{historyQuery.data.map(download => {
									return (
										<TableRow key={download.id}>
											<TableCell>
												{download.firstName} {download.lastName}
											</TableCell>
											<TableCell>{download.organization}</TableCell>
											<TableCell>
												{GetDocumentDownloadTypeDescription(download.downloadType)}
											</TableCell>
											<TableCell>
												{DateUtils.FormatStringAsShortDate(download.createdOn.toString())}
											</TableCell>
										</TableRow>
									);
								})}
								{historyQuery.data.length == 0 && (
									<TableRow>
										<TableCell colSpan={4} style={{ textAlign: 'center' }}>
											This document has not been downloaded yet.
										</TableCell>
									</TableRow>
								)}
							</>
						)}
					</TableBody>
				</Table>
			</TableContainer>
		</CerebroDrawer>
	);
};
